// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.
import { Theme, createStyles, makeStyles } from "@material-ui/core";

import { Button } from "../ui/Buttons";
import DeclarativeList from "components/DeclarativeComponents/DeclarativeList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import PageContent from "../ui/PageContent";
import PageHeader from "../ui/PageHeader";
import React from "react";
import { fbt } from "fbt";

const style = makeStyles((theme: Theme) =>
  createStyles({
    nextButton: {
      minWidth: "185px",
      margin: "40px",
      display: "block",
      marginLeft: "auto",
      marginRight: "auto",
    },
    text: {
      marginTop: "40px",
    },
  })
);

export default () => {
  const styles = style();

  return (
    <PageContent>
      <PageHeader title="Finishing up" />
      <div className="container">
        <p className={styles.text}>
          You completed your at-home COVID-19 test.
          <DeclarativeList>
            <li>
              <fbt desc="cleanup: put away supplies" project="audere">
                Please put all your used supplies in the provided plastic bag,
                seal it, and toss it in the bin.
              </fbt>
            </li>
            <li>
              <fbt desc="cleanup: put away supplies" project="audere">
                Thoroughly wash and dry your hands.
              </fbt>
            </li>
          </DeclarativeList>
        </p>
        <p>
          By taking this test you are helping scientists and the NHS learn more
          about COVID-19, including where the virus has spread in the UK and how
          it is affecting your community.
        </p>
        <br />
        <p>Take a look at the following links to learn more about COVID-19:</p>
        <br />
        <p>
          <a href="https://www.nhs.uk/conditions/coronavirus-covid-19/">
            Latest NHS news about COVID-19
          </a>
        </p>
        <p>
          <a href="https://www.nhs.uk/conditions/coronavirus-covid-19/">
            How to protect yourself and others
          </a>
        </p>
        <Link to={"/nhs/newtestrun"}>
          <Button className={styles.nextButton} size="large">
            <span>Return Home</span>
            <span className="icon is-medium">
              <FontAwesomeIcon icon="home" />
            </span>
          </Button>
        </Link>
      </div>
    </PageContent>
  );
};
